<template>
  <div class="grid">
    <div class="left">
      <slot name="left" />
    </div>
    <div class="right">
      <slot name="right" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.grid {
  display: grid;
  gap: $spacing-6;

  @include desktop {
    grid-template-columns: 2fr 1.4fr;
  }

  .left,
  .right {
    @include flex-column($spacing-4);

    :deep(.card) {
      gap: $spacing-3;

      @include desktop {
        padding: $spacing-8;
      }
    }
  }

  .right {
    @include desktop {
      position: sticky;
      top: $spacing-6;
      align-self: start;
    }
  }
}
</style>
